/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Display_Thank_YouInputs */

const vi_customer_display_thank_you = /** @type {(inputs: Customer_Display_Thank_YouInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cảm ơn quý khách!`)
};

/**

* @param {Customer_Display_Thank_YouInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_display_thank_you = /** @type {((inputs?: Customer_Display_Thank_YouInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Display_Thank_YouInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_display_thank_you(inputs)
});